import HttpRequest from './HttpRequest'

class VerdictProvider extends HttpRequest {
  findAll () {
    return this.get('/judgment-decision')
  }

  findOne (id) {
    return this.get(`/judgment-decision/${id}`)
  }

  create (payload) {
    return this.post('/judgment-decision', payload)
  }

  update (id, payload) {
    return this.patch(`/judgment-decision/${id}`, payload)
  }

  softDelete (id) {
    return this.delete(`/judgment-decision/${id}`)
  }

  paginate (page = 1, limit = 10, query) {
    return this.get(`/judgment-decision?page=${page}&limit=${limit}`, query)
  }
}

export default VerdictProvider
